import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../../models/api.model';
import { Upsell } from '../models/upsell.model';

@Injectable({
  providedIn: 'root',
})
export class UpsellService {
  private apiRoot = '/bo/event-upsells';

  constructor(private http: HttpClient) {}

  public getAll$(page?: number): Observable<ApiResponse<Upsell[]>> {
    let query = '';
    if (page) {
      query = '?page=' + page;
    }
    return this.http.get<ApiResponse<Upsell[]>>(
      environment.apiURl + `${this.apiRoot}${query}`
    );
  }

  public get$(id: number): Observable<ApiResponse<Upsell>> {
    return this.http.get<ApiResponse<Upsell>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public create$(
    body: Upsell,
    file?: File,
    nm?: Array<string | number>
  ): Observable<ApiResponse<Upsell>> {
    let formData: FormData = new FormData();
    let options = {};
    if (file) {
      formData.append('image', file, file.name);
    }

    formData.append('active', body.active.toString());
    if (body.name) {
      formData.append('name', body.name);
    }
    if (body.description) {
      formData.append('description', body.description);
    }
    if (body.buyerTypeId) {
      formData.append('buyerTypeId', String(body.buyerTypeId));
    }
    if (body.buyerTypeName) {
      formData.append('buyerTypeName', body.buyerTypeName);
    }
    if (body.price) {
      formData.append('price', `${body.price}`);
    }
    if (nm) {
      if (nm.length) {
        nm.forEach(i => {
          formData.append('events[]', i.toString());
        });
      } else {
        formData.append('events', '[]');
      }
    }
    return this.http.post<ApiResponse<Upsell>>(
      environment.apiURl + `${this.apiRoot}`,
      formData,
      options
    );
  }

  public delete$(id: number): Observable<ApiResponse<Pick<Upsell, 'id'>>> {
    return this.http.delete<ApiResponse<Pick<Upsell, 'id'>>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public update$(
    body: Upsell,
    file?: File,
    nm?: Array<string | number>
  ): Observable<ApiResponse<Upsell>> {
    let formData: FormData = new FormData();
    let options = {};
    if (file) {
      formData.append('image', file, file.name);
    }
    formData.append('active', body.active.toString());
    if (body.name) {
      formData.append('name', body.name);
    }
    if (body.description) {
      formData.append('description', body.description);
    }
    if (body.buyerTypeId) {
      formData.append('buyerTypeId', String(body.buyerTypeId));
    }
    if (body.buyerTypeName) {
      formData.append('buyerTypeName', body.buyerTypeName);
    }
    if (body.price) {
      formData.append('price', body.price.toString(10));
    }
    if (body.urlImage == null) {
      formData.append('urlImage', 'null');
    } else {
      const endIndex =
        body.urlImage.indexOf('?') > -1 ? body.urlImage.indexOf('?') : Infinity;
      formData.append('urlImage', body.urlImage.substring(0, endIndex));
    }
    if (nm) {
      if (nm.length) {
        nm.forEach(i => {
          formData.append('events[]', i.toString());
        });
      } else {
        formData.append('events', '[]');
      }
    }

    return this.http.patch<ApiResponse<Upsell>>(
      environment.apiURl + `${this.apiRoot}/${body.id}`,
      formData,
      options
    );
  }
}
